import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazy } from 'react';

const Account = lazy(() => import('./Account'));

const AccountRoute: FuseRouteItemType = {
    path: 'account/:page',
    element: <Account />,
    settings: {
        layout: {
            config: {
                toolbar: {
                    title: 'Account',
                    helpName: 'Account',
                    showCrumbs: false,
                }
            }
        }
    }
};

export default AccountRoute;
